var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner",class:_vm.size},[_c('b-spinner',{attrs:{"variant":_vm.variant}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }